export const userAvatarPlaceholder = '9f74f44fae55359ddab31eecddb2b6774bf7fa7b6cf9d42adf23490bfe021d11.png';

export const companyAvatarPlaceholder = '18a5e358f1ba1d2f51044562a3135afcfec735a1b09b0ebc70d743a13be4dbde.jpg';
